import React, { useState, useRef, useEffect } from 'react';
import './CustomSelect.css';

interface CustomSelectProps {
    value: string;
    onChange: (value: string) => void;
    options: { value: string; label: string }[];
    className?: string;
}

export const CustomSelect: React.FC<CustomSelectProps> = ({ value, onChange, options, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const selectedOption = options.find(opt => opt.value === value) || options[0];

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleSelect = (optionValue: string) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    return (
        <div className={`CustomSelect ${className || ''}`} ref={dropdownRef}>
            <div 
                className={`CustomSelect_trigger ${isOpen ? 'CustomSelect_trigger--open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="CustomSelect_value">{selectedOption.label}</span>
                <svg 
                    className="CustomSelect_arrow" 
                    width="12" 
                    height="8" 
                    viewBox="0 0 12 8"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path fill="#666666" d="M0 0l6 8 6-8z"/>
                </svg>
            </div>
            
            {isOpen && (
                <div className="CustomSelect_dropdown">
                    {options.map(option => (
                        <div
                            key={option.value}
                            className={`CustomSelect_option ${option.value === value ? 'CustomSelect_option--selected' : ''}`}
                            onClick={() => handleSelect(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
